export const VERIFIED = 'verified';
